import { APP_VERSION } from '@/config/downloads';
import { useLocale } from '@/i18n/locale-context';
import { cn } from '@/lib/utils';

export function SiteFooter({ className }: { className?: string }) {
  const { t } = useLocale();

  return (
    <footer
      className={cn(
        'flex flex-col items-center gap-2.5 px-6 pb-8 pt-5 text-center text-xs text-muted-foreground',
        className
      )}
    >
      <p className="max-w-md leading-relaxed">{t.footer.privacy}</p>
      <p className="text-[11px] italic text-muted-foreground/70">
        「本地优先 · AI 驱动 · 可编辑知识」
      </p>
      <p className="text-[11px] text-muted-foreground/80">
        <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400/80 mr-1.5 align-middle" />
        v{APP_VERSION} · © {new Date().getFullYear()} Blendviewer
      </p>
    </footer>
  );
}
